import { render, staticRenderFns } from "./teacherTable.vue?vue&type=template&id=233d61b0&scoped=true&"
import script from "./teacherTable.vue?vue&type=script&lang=js&"
export * from "./teacherTable.vue?vue&type=script&lang=js&"
import style0 from "./teacherTable.vue?vue&type=style&index=0&id=233d61b0&prod&scoped=true&lang=scss&"
import style1 from "./teacherTable.vue?vue&type=style&index=1&id=233d61b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233d61b0",
  null
  
)

export default component.exports